<template>
    <b-container fluid class="p-3">
        <div class="w-50 mx-auto">            
            <h1 class="font-weight-bold text-center mt-0">{{ title }}</h1>
            <h2 class="font-weight-bold text-center">{{ subtitle }}</h2>
            <p class="lead text-center">{{ description }}</p>
            <b-img
                :src="`${routes.cdn_url}/images/redesign/animals/kevin-sitting.svg`"
                class="d-flex animal-svg mx-auto w-50"
                alt="Kevin, NGM's loyal mathscot, sitting criss-cross applesauce on the floor reading a book."
            ></b-img>
        </div>
    </b-container>
</template>

<script>
    export default {
        props: {
            status: Number,
        },
        computed: {
            title() {
                return {
                    503: '503',
                    502: '502',
                    500: '500',
                    404: '404',
                    403: '403',
                }[this.status]
            },
            subtitle() {
                return {
                    503: 'Service Unavailable',
                    502: 'Bad Gateway',
                    500: 'Server Error',
                    404: 'Page Not Found',
                    403: 'Forbidden',
                }[this.status]
            },

            description() {
                return {
                    503: "Oops! Kevin's busy digging up some fascinating math facts. He'll be back in a jiffy to guide you through your mathematical journey. Please wait a moment and try again.",
                    502: "Oh, dear! Kevin's chasing his tail around a mathematical loop. We're training him to break free, but in the meantime, let's backtrack and try a different equation together.",
                    500: "Woof! Kevin got tangled up in a math equation. Our team of mathematicians is working hard to untangle him and restore balance. Please bear with us while we fetch a solution.",
                    404: "Uh-oh! Kevin has sniffed out every nook and cranny, but he couldn't find the bone you're looking for. It seems to have rolled into a different math dimension. Let's head back and explore another path.",
                    403: "Oh no! Kevin's wagging his tail and guarding this page, but it seems you don't have the right math password to enter. Double-check your calculations and try again!",
                }[this.status]
            },
        },
    }
</script>

<style>
h1 {
    font-size: 5rem;
}
</style>